import { PARTNER_COMPANY_PERSONAL_TYPE } from './constants';
import { isNullOrUndefinedOrEmptyStr } from './stringUtil';

export const getLabelPersonalCompanyType = oneOwnerFlag => {
  let label = '未設定';
  if (isOneOwnerCompany(oneOwnerFlag)) {
    label = PARTNER_COMPANY_PERSONAL_TYPE.oneOwner.label;
  } else if (!isNullOrUndefinedOrEmptyStr(oneOwnerFlag)) {
    label = PARTNER_COMPANY_PERSONAL_TYPE.default.label;
  }
  return label;
};

export const isOneOwnerCompany = oneOwnerFlag => {
  return oneOwnerFlag === PARTNER_COMPANY_PERSONAL_TYPE.oneOwner.value;
};



// WEBPACK FOOTER //
// ./src/utilities/partnerCompanyUtil.js